import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '../../core/components';
import { CompanyTypeService } from '../../services';
import { modalLarge } from '../../shared/modules/dialogOptions';
import { CompanyTypeCreateComponent } from './company-type-create.component';
import { CompanyTypeListComponent } from './company-type-list.component';
@Component({
    selector: 'app-company-type',
    templateUrl: './company-type.component.html',
    styleUrls: ['../layout/layout.component.scss']
})
export class CompanyTypeComponent extends BaseComponent implements OnInit {
    @ViewChild('companyTypeList') companyTypeList: CompanyTypeListComponent;
    public isAdminOrUserEditor: boolean;

    constructor(
        public router: Router,
        private route: ActivatedRoute,
        private companyTypeService: CompanyTypeService,
        public activeModal: NgbActiveModal,
        private modalService: NgbModal,
        private location: Location) {
        super(router)
    }

    ngOnInit() {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'))
        if (currentUser.role === 'admin') {
            this.isAdminOrUserEditor = true;
            this.companyTypeList.isAdminOrUserEditor = true;
            this.companyTypeList.loadDataById(currentUser.accountId);
        }
        else if (currentUser.role === 'user') {
            this.isAdminOrUserEditor = false;
        }
        else if (currentUser.role === 'superadmin') {
            this.companyTypeList.isSuperAdmin = true;
            let secondaryUserData = super.secondaryAdminUser();
            if (secondaryUserData) {
                this.companyTypeList.loadDataById(secondaryUserData.AccountId);
            }
        }

        //  this.loadSetting();
    }

    public openCreateCompanyType(type: string): void {
        //var data = new Type3Component();            
        const modalRef = this.modalService.open(CompanyTypeCreateComponent, modalLarge);

        modalRef.result.then((result) => {
            this.ngOnInit();
            //this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.ngOnInit();
            //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
        //modalRef.componentInstance.SiteIdFromModal = this.SiteId;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/company-type/company-type.component.ts